import { useMutation } from "react-query";
import { PessoaContato } from "features/unidades/typings/unidade";
import http from "infra/http";

function useSaveContato() {
  return useMutation(
    `/v1/contato`,
    (data: PessoaContato & { pessoaId: string }) =>
      data.id
        ? http.put(`/v1/contato/${data.id}`, data)
        : http.post(`/v1/contato`, data),
    { retry: false }
  );
}

export default useSaveContato;
